import { AppIconTooltip } from '@/ui/icon-tooltip/AppIconTooltip';
import classNames from 'classnames';
import { get } from 'lodash';
import { InputText, InputTextProps } from 'primereact/inputtext';
import React, { SyntheticEvent } from 'react';

export type FormikIconInputProps = {
  field: {
    name: string;
    value: string;
    onChange: () => void;
    onBlur: (e: SyntheticEvent<HTMLInputElement>) => void;
  };
  form: {
    touched: Record<string, any>;
    errors: Record<string, any>;
    setFieldValue: (
      field: string,
      value: any,
      shouldValidate?: boolean,
    ) => void;
  };
  label?: string;
  additionOnBlur?: () => void;
  icon?: React.ReactNode;
  inputState?: 'exists-active' | 'exists-inactive' | 'exists-error';
  inputStateMessage?: string;
  tooltip?: string;
  labelChip?: React.ReactNode;
};

export const FormikIconInput: React.FC<
  FormikIconInputProps & InputTextProps
> = ({
  field,
  form,
  label,
  className,
  required,
  additionOnBlur,
  icon,
  inputState,
  inputStateMessage,
  tooltip,
  labelChip,
  ...rest
}) => {
  const fieldError = get(form.errors, field.name);
  const fieldTouched = get(form.touched, field.name);

  return (
    <>
      {!!label && (
        <label
          htmlFor={field.name}
          className={classNames({
            'p-error':
              (fieldTouched && !!fieldError) ||
              (inputState === 'exists-error' &&
                !(fieldTouched && !!fieldError)),
            'p-exists-active':
              inputState === 'exists-active' && !(fieldTouched && !!fieldError),
            'p-exists-inactive':
              inputState === 'exists-inactive' &&
              !(fieldTouched && !!fieldError),
          })}
        >
          {label}
          {required ? <span className="red"> *</span> : ''}
          {!!tooltip && (
            <AppIconTooltip
              target={`${field.name}-icon`}
              content={tooltip}
              position="top"
            />
          )}
          {labelChip}
        </label>
      )}
      <div className="p-input-icon-right w-full mt-2">
        <InputText
          {...field}
          value={field.value ?? ''}
          {...rest}
          className={classNames(className, {
            'p-invalid':
              (fieldTouched && !!fieldError) ||
              (inputState === 'exists-error' &&
                !(fieldTouched && !!fieldError)),
            'p-exists-active':
              inputState === 'exists-active' && !(fieldTouched && !!fieldError),
            'p-exists-inactive':
              inputState === 'exists-inactive' &&
              !(fieldTouched && !!fieldError),
          })}
          onBlur={(e: SyntheticEvent<HTMLInputElement>) => {
            field.onBlur(e);
            form.setFieldValue(field.name, field.value?.trim());

            if (additionOnBlur) {
              additionOnBlur();
            }
          }}
          autoComplete="off"
        />
        {icon}
      </div>

      {fieldTouched && !!fieldError ? (
        <small className="p-error">{fieldError}</small>
      ) : inputState === 'exists-error' && inputStateMessage ? (
        <small className="p-error">{inputStateMessage}</small>
      ) : inputState === 'exists-active' && inputStateMessage ? (
        <small className="p-exists-active">{inputStateMessage}</small>
      ) : inputState === 'exists-inactive' && inputStateMessage ? (
        <small className="p-exists-inactive">{inputStateMessage}</small>
      ) : null}
    </>
  );
};
